// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	console.log($w('Document'))
	//TODO: write your page related code here...
	$w("#html6").hide("fade");

	var piAId = '512451';
	var piCId = '34316';
	var piHostname = 'pi.pardot.com';

	(function() {
		function async_load(){
			var s = document.createElement('script'); s.type = 'text/javascript';
			s.src = ('https:' == document.location.protocol ? 'https://pi' : 'http://cdn') + '.pardot.com/pd.js';
			var c = document.getElementsByTagName('script')[0]; c.parentNode.insertBefore(s, c);
		}
		if(window.attachEvent) { window.attachEvent('onload', async_load); }
		else { window.addEventListener('load', async_load, false); }
	})();
});

